import { render, staticRenderFns } from "./MsInput.vue?vue&type=template&id=3cb2876b&"
import script from "./MsInput.vue?vue&type=script&lang=js&"
export * from "./MsInput.vue?vue&type=script&lang=js&"
import style0 from "./MsInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports